// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3XTnc","boxTitle":"Qualiphy_boxTitle__3Aj8c","box":"Qualiphy_box__3_icV","toggleWrap":"Qualiphy_toggleWrap__1d76_"};